var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEntryExitDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 22,
    viewBox: "0 0 46 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.5H8C7.6 21.5 7.22 21.34 6.94 21.06C6.66 20.78 6.5 20.4 6.5 20V17.75H8V20H17V2H8V4.25H6.5V2C6.5 1.6 6.66 1.22 6.94 0.94C7.22 0.66 7.6 0.5 8 0.5H17C17.4 0.5 17.78 0.66 18.06 0.94C18.34 1.22 18.5 1.6 18.5 2V20C18.5 20.4 18.34 20.78 18.06 21.06C17.78 21.34 17.4 21.5 17 21.5Z",
    fill: "#009966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 14.44L11.12 11.75H0.5V10.25H11.13L8.45 7.56L9.51 6.5L14.01 11L9.51 15.5L8.45 14.44H8.44Z",
    fill: "#009966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21.5H38C38.3977 21.4995 38.779 21.3414 39.0602 21.0602C39.3414 20.7789 39.4995 20.3977 39.5 20V17.75H38V20H29V2H38V4.25H39.5V2C39.4995 1.60232 39.3414 1.22105 39.0602 0.939844C38.779 0.658638 38.3977 0.500457 38 0.5H29C28.6023 0.500457 28.2211 0.658638 27.9398 0.939844C27.6586 1.22105 27.5005 1.60232 27.5 2V20C27.5005 20.3977 27.6586 20.7789 27.9398 21.0602C28.2211 21.3414 28.6023 21.4995 29 21.5Z",
    fill: "#E7000B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9395 14.4395L42.629 11.75H32V10.25H42.629L39.9395 7.5605L41 6.5L45.5 11L41 15.5L39.9395 14.4395Z",
    fill: "#E7000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEntryExitDevice);
export default __webpack_public_path__ + "static/media/ic-entry-exit-device.3390899d3cf56d200e17b34ddc68de89.svg";
export { ForwardRef as ReactComponent };